<div class="d-flex flex-column justify-content-center">
    <div class="m-2">
        <input pInputText type="text" placeholder="Gift Card #" name="giftAccount" [(ngModel)]="giftCardNumber" required class="w-100" />
    </div>
    
    <div *ngIf="detailMessage" class="m-2">
        <h4>{{detailMessage}}</h4>
    </div>
    <button [disabled]="giftCardBalance" pButton pRipple class="p-button-raised p-button-success m-2 w-100" label="Check Balance"
        (click)="processBalanceCheck(giftCardNumber)" [ladda]="saving">
        <fa-icon [icon]='["far","balance-scale-right"]'></fa-icon>
    </button>
</div>


<p-dialog *ngIf="giftCardNumber && zeroBalance" header="Gift Card {{giftCardNumber.toString().substring(giftCardNumber.length - 4)}} = $0.00" [(visible)]="zeroBalance" appendTo="body">
    <div class="d-flex">
        Gift Card {{giftCardNumber.toString().substring(giftCardNumber.length - 4)}} has a zero balance.
    </div>
</p-dialog>